import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { SundrySummaryWorkDistributionSchemaObject } from "../SundrySummaryWorkDistributionSchema";
import { validateProperty } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import { TableRow } from "@material-ui/core";
import MessageModal from "../../../../UI/Modal/MessageModal";

const screenCode = "SUNDRYSUMMARYWORKDISTRIBUTIONREPORT";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    },
    stickyHeader: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
    stickyColumn: {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
});

export function SundrySummaryWorkDistributionReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [numOfDays, setNumOfDays] = useState([]);
    const [headings, setHeadings] = useState([])
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });
    const [sundrySummaryDetails, setSundrySummaryDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        month: "",
        year: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        month: "",
        year: ""
    })

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const contentRowNames = ["estateName", "divisionName", "employeeName", "employeeID", "days", "qty"]
    const [reportData, setReportData] = useState([]);
    const [allTotal, setAllTotal] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [sundrySummaryDetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [sundrySummaryDetails.estateID])

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [sundrySummaryDetails.groupID]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [sundrySummaryDetails.estateID]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [sundrySummaryDetails.divisionID]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [sundrySummaryDetails.month]);

    useEffect(() => {
        setReportData([])
        setIsTableHide(true)
    }, [sundrySummaryDetails.year]);

    function clearTable() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
        setSundrySummaryDetails({
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            month: "",
            year: ""
        })
    }

    function handleGroupChange(target) {
        validateInputs(target);
        setSundrySummaryDetails({
            ...sundrySummaryDetails,
            groupID: target.value,
            estateID: "0",
            divisionID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);
        setSundrySummaryDetails({
            ...sundrySummaryDetails,
            estateID: target.value,
            divisionID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);
        setSundrySummaryDetails({
            ...sundrySummaryDetails,
            divisionID: target.value
        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);
        setSundrySummaryDetails({
            ...sundrySummaryDetails,
            month: target.value,
            year: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, SundrySummaryWorkDistributionSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUNDRYSUMMARYWORKDISTRIBUTIONREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setSundrySummaryDetails({
                ...sundrySummaryDetails,
                groupID: token.groupID
            });

        } else {
            setSundrySummaryDetails({
                ...sundrySummaryDetails,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }

        setSundrySummaryDetails({
            ...sundrySummaryDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(sundrySummaryDetails.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(sundrySummaryDetails.estateID);
        setDivisions(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function getdata(e) {
        e.preventDefault();
        const validationErrors = {};

        if (sundrySummaryDetails.groupID === "0") {
            validationErrors.groupID = "Group is required";
        }
        if (sundrySummaryDetails.estateID === "0") {
            validationErrors.estateID = "Operation Entity is required";
        }
        if (sundrySummaryDetails.divisionID === "0") {
            validationErrors.divisionID = "Collection Point is required";
        }
        if (!sundrySummaryDetails.month) {
            validationErrors.month = "Month is required";
        }
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setIsTableHide(true);
        setButtonHide(true);
        getSelectedDropdownValuesForReport(sundrySummaryDetails);
        setIsTableHide(true);

        var model = {
            groupID: parseInt(sundrySummaryDetails.groupID),
            estateID: parseInt(sundrySummaryDetails.estateID),
            divisionID: parseInt(sundrySummaryDetails.divisionID),
            month: sundrySummaryDetails.month,
            year: sundrySummaryDetails.year
        }
        const res = await services.GetSundrySummaryWorkDistributionData(model);
        let monthValue = model.month;
        const month = monthValue.split('-')[1];
        const year = monthValue.split('-')[0];
        function getDaysInMonth(year, month) {
            return new Date(year, month, 0).getDate();
        }
        const value = getDaysInMonth(year, month);
        const csvHeaders = [];
        csvHeaders.push({ label: "Task Name", value: "taskName" })
        let dateArray = [];
        for (let i = 0; i < value; i++) {
            var dayLength = ((i + 1).toString()).length
            dateArray.push((dayLength == 1 ? ('0' + (i + 1)).toString() : (i + 1).toString()).toString())
            csvHeaders.push({ label: ('day ' + (i + 1)).toString(), value: (dayLength == 1 ? ('0' + (i + 1)).toString() : (i + 1).toString()).toString() })
        }
        csvHeaders.push({ label: "Total", value: "total" })
        let newRes = _.cloneDeep(res);

        var result = [];
        var totalRow = [];
        totalRow.push({ name: "taskName", value: "Total" });
        var totalOfAllrecords = 0;
        newRes.forEach(z => {

            z.dataList.forEach(x => {
                const date = x.createdDate.split('T')[0];
                const day = date.split('-')[2];

                var duplicateTotalRowData = totalRow.find(y => y.name === day);
                if (duplicateTotalRowData) {
                    duplicateTotalRowData.value = duplicateTotalRowData.value + x.employeeCount;
                } else {
                    totalRow.push({ name: day, value: x.employeeCount });
                }

                var duplicateDate = result.find(y => y.taskID === x.taskID);
                if (duplicateDate) {
                    duplicateDate[day] = duplicateDate[day] == undefined ? 0 + x.employeeCount : duplicateDate[day] + x.employeeCount;
                    duplicateDate.taskName = x.taskName;
                    duplicateDate.estateTaskCategory = x.estateTaskCategory;
                    duplicateDate.taskID = x.taskID;
                    duplicateDate.total = duplicateDate.total == undefined ? 0 + x.employeeCount : duplicateDate.total + x.employeeCount;
                    totalOfAllrecords = totalOfAllrecords + x.employeeCount;
                }
                else {
                    result.push({
                        [day]: x.employeeCount,
                        taskName: x.taskName,
                        estateTaskCategory: x.estateTaskCategory,
                        taskID: x.taskID,
                        total: x.employeeCount
                    });
                    totalOfAllrecords = totalOfAllrecords + x.employeeCount;
                }
            });
        });
        totalRow.push({ name: "total", value: parseFloat(totalOfAllrecords) });

        setHeadings(csvHeaders)
        setReportData(result);
        setNumOfDays(dateArray);
        setTotal(totalOfAllrecords);
        setAllTotal(totalRow)

        if (result.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setButtonHide(false);
        setIsReportButtonsEnabled();
    }

    function createFile() {
        var settings = {
            sheetName: 'SSWorkDistributionReport',
            fileName: 'Sundry Summary Work Distribution Report',
            writeOptions: {}
        }

        var copyOfCsv = [...reportData]
        let newAllTotal = _.cloneDeep(allTotal);

        const obj = newAllTotal.reduce((acc, cur) => {
            acc[cur.name] = cur.value;
            return acc;
        }, {});

        var newRow1 = {
            taskName: "Group : " + groups[sundrySummaryDetails.groupID]
        }
        var newRow2 = {
            taskName: "Operation Entity : " + estates[sundrySummaryDetails.estateID]
        }
        var newRow3 = {
            taskName: sundrySummaryDetails.divisionID == "0" ? "Collection Point : All Collection Points"
                : "Collection Point : " + divisions[sundrySummaryDetails.divisionID]
        }
        var newRow4 = {
            taskName: "Month : " + sundrySummaryDetails.month
        }
        copyOfCsv.push(obj, {}, {}, newRow1, newRow2, newRow3, newRow4)
        xlsx(headings, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            month: searchForm.month
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Sundry Summary Work Distribution Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={sundrySummaryDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID"> Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={sundrySummaryDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point * </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={sundrySummaryDetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">-- Select Collection Point --</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="month">Month and Year *</InputLabel>
                                        <TextField
                                            fullWidth
                                            placeholder="-- Select Month --"
                                            id="month"
                                            name="month"
                                            type="month"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["month"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(getdata(e))}
                                    />
                                    <input type="reset" className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={clearTable}
                                    />
                                </div>
                            </form>
                            {reportData.length > 0 ?
                                <div style={{ width: '1350px' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <Box display="flex" justifyContent="flex-end" >
                                                    <TableContainer component={Paper} style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                        <Table className={classes.table} size="small" aria-label="sticky table" stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell className={classes.sticky} align="center" style={{ fontWeight: "bold" }}>Task Name</TableCell>
                                                                    {numOfDays.map((count, i) => (
                                                                        <TableCell className={`${classes.stickyHeader}`} key={i} align="center" style={{ fontWeight: "bold" }}>{count}</TableCell>
                                                                    ))}
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {reportData.map((rows, i) => (
                                                                    <TableRow key={i} >
                                                                        <TableCell component="th" scope="row" align="left" style={{ position: "sticky", left: 0, zIndex: 1, backgroundColor: "white" }}> {rows.taskName}</TableCell>
                                                                        {numOfDays.map((count) => {
                                                                            const result = rows[count]
                                                                            return (
                                                                                <TableCell component="th" scope="row" align="center"> {result == undefined ? '-' : result}</TableCell>
                                                                            );
                                                                        })}
                                                                        <TableCell component="th" scope="row" align="center"> {rows.total}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                                <TableRow>
                                                                    <TableCell className={`${classes.stickyColumn}`} component="th" scope="row" align="center" colSpan={1} style={{ fontWeight: "bold" }}> Total</TableCell>
                                                                    {numOfDays.map((column) => {
                                                                        const value = allTotal.find(x => x.name == column)
                                                                        return (
                                                                            <TableCell style={{ fontWeight: "bold" }} align='center'>{value == undefined ? '-' :
                                                                                parseFloat(value.value)}</TableCell>
                                                                        );
                                                                    })}
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(total)}</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null}
                            {isTableHide ? null :
                                <div>
                                    <br />
                                    <>
                                        <div className="pt-2" justify-content="center" >
                                            <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="Excel"
                                                onClick={createFile}
                                            />
                                            <ReactToPrint
                                                documentTitle={" Sundry Summary Work Distribution Report"}
                                                trigger={() => <input
                                                    type="submit"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="PDF"
                                                />}
                                                content={() => componentRef.current}
                                            />
                                        </div>
                                        <div hidden={true}>
                                            <CreatePdf ref={componentRef} data={reportData} allTotal={allTotal} total={total}
                                                rowNames={contentRowNames} searchData={selectedSearchValues} daysCount={numOfDays} />
                                        </div>
                                    </>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}
